export enum CategoryIdE {
  Undefined = 'Undefined',
  WhatsNew = 'WhatsNew',
  BugFix = 'BugFix',
}
